/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { RestClientService } from 'app/shared/services/rest-client.service';
import { Observable } from 'rxjs';
import { StaticDataType } from 'app/static-data/models';
import { map, catchError } from 'rxjs/operators';
import { observableThrow } from 'app/shared/rxjs/rxjs.utils';
import { Location } from '@angular/common';
import { environment } from 'environments/environment';
import { NamedValue } from 'app/shared/models';

/** Returns data from the API. */
@Injectable()
export class ApiDataService extends DataService {
  private readonly enumerationEndpoint = 'config/static-data/enumeration';

  loadEnumerationValues(enumType: StaticDataType): Observable<NamedValue<string>[]> {
    return this.loadValues(enumType).pipe(map((values: string[]) => this.toNamedValues(values)));
  }

  private loadValues(configType: StaticDataType): Observable<string[]> {
    const queryParams = { type: configType };
    return this.client
      .get<string[]>(
        Location.joinWithSlash(environment.baseUrl, this.enumerationEndpoint),
        queryParams
      )
      .pipe(
        map(res => res.body!),
        catchError(() => observableThrow('Error loading values of type: ' + configType))
      );
  }

  private toNamedValues(values: string[]): NamedValue<string>[] {
    return values.map(
      value =>
        <NamedValue<string>>{
          name: value,
          value: value
        }
    );
  }

  constructor(private client: RestClientService) {
    super();
  }
}
